import React from 'react'

function Line({ dashed }: { dashed?: boolean }) {
    const styles = {
        borderTop: `1px ${dashed ? 'dashed' : 'solid'} #222222`,
    }
    return <hr style={styles} />
}
export default Line
